var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenewal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.062,
    height: 21.908,
    viewBox: "0 0 23.062 21.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3881",
    "data-name": "Rectangle 3881",
    width: 23.062,
    height: 21.908,
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13241",
    "data-name": "Group 13241",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13237",
    "data-name": "Group 13237",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42364",
    "data-name": "Path 42364",
    d: "M10.077,4.3c.046-.067.075-.116.111-.159A7.526,7.526,0,0,1,17.709,1.2,7.442,7.442,0,0,1,22.8,4.6a7.9,7.9,0,0,1,1.3,4.35.513.513,0,0,0,.529.54.507.507,0,0,0,.5-.551,11.078,11.078,0,0,0-.08-1.2,8.818,8.818,0,0,0-3.257-5.785A8.4,8.4,0,0,0,14.912.125,8.6,8.6,0,0,0,9.8,2.972c-.06.067-.118.136-.208.24,0-.2,0-.348,0-.5a.518.518,0,1,0-1.03,0q0,1.059,0,2.119a.539.539,0,0,0,.635.592l1.937-.131a.517.517,0,0,0,.521-.55.509.509,0,0,0-.551-.5c-.332.01-.663.037-1.026.058",
    transform: "translate(-5.189 1.589)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42365",
    "data-name": "Path 42365",
    d: "M0,69.148c.014-.024.03-.048.042-.072a.523.523,0,0,1,.58-.3.525.525,0,0,1,.408.534,7.745,7.745,0,0,0,.452,2.62,7.618,7.618,0,0,0,5.571,5.058,7.42,7.42,0,0,0,6.777-1.676,6.889,6.889,0,0,0,1.23-1.352L14.38,74c-.137.008-.275.021-.412.017a.524.524,0,0,1-.042-1.042c.7-.053,1.394-.1,2.091-.138a.516.516,0,0,1,.555.551q0,1.094,0,2.188a.515.515,0,1,1-1.029,0c0-.157,0-.313,0-.516l-.169.188a8.8,8.8,0,0,1-5.158,2.9c-.274.049-.552.077-.829.114H8.218c-.049-.011-.1-.026-.148-.033-.311-.044-.626-.07-.934-.131a8.573,8.573,0,0,1-4.514-2.431,8.836,8.836,0,0,1-2.484-4.81c-.056-.32-.093-.644-.138-.966v-.735",
    transform: "translate(2.34 -58.729)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42366",
    "data-name": "Path 42366",
    d: "M10.077,4.3c.363-.021.694-.048,1.026-.058a.509.509,0,0,1,.551.5.517.517,0,0,1-.521.55L9.2,5.424a.539.539,0,0,1-.635-.592q0-1.059,0-2.119a.518.518,0,1,1,1.03,0c0,.149,0,.3,0,.5.09-.1.148-.173.208-.24A8.6,8.6,0,0,1,14.912.125a8.4,8.4,0,0,1,6.881,1.829A8.818,8.818,0,0,1,25.051,7.74a11.078,11.078,0,0,1,.08,1.2.507.507,0,0,1-.5.551.513.513,0,0,1-.529-.54A7.9,7.9,0,0,0,22.8,4.6,7.442,7.442,0,0,0,17.709,1.2a7.526,7.526,0,0,0-7.522,2.945c-.035.044-.065.093-.111.159",
    transform: "translate(-5.189 1.589)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewal);
export default __webpack_public_path__ + "static/media/renewal.3485b5dc.svg";
export { ForwardRef as ReactComponent };